module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-5 mb-10"
  }, [_c('section', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mb-4",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex align-center gap-15 pa-3"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/chat.svg'),
      "height": "45",
      "width": "45"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-size-12"
  }, [_vm._v("\n                                Total Aktivitas Konsul\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text mt-1 font-size-24"
  }, [_vm._v("\n                                " + _vm._s(_vm.formatNumber(_vm.data.total_consul)) + "\n                                "), _c('span', {
    staticClass: "font-size-12 font-weight-500"
  }, [_vm._v("\n                                    Aktivitas\n                                ")])])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex align-center gap-10 pa-3"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/bell.svg'),
      "height": "45",
      "width": "45"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-size-12"
  }, [_vm._v("\n                                Status Started\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text mt-1 font-size-24"
  }, [_vm._v("\n                                " + _vm._s(_vm.formatNumber(_vm.data.total_consul_started)) + "\n                                "), _c('span', {
    staticClass: "font-size-12 font-weight-500"
  }, [_vm._v("\n                                    Started\n                                ")])])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex align-center gap-10 pa-3"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/waiting.svg'),
      "height": "45",
      "width": "45"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-size-12"
  }, [_vm._v("\n                                Status Waiting\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text mt-1 font-size-24"
  }, [_vm._v("\n                                " + _vm._s(_vm.formatNumber(_vm.data.total_consul_waiting)) + "\n                                "), _c('span', {
    staticClass: "font-size-12 font-weight-500"
  }, [_vm._v("\n                                    Waiting\n                                ")])])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex align-center gap-10 pa-3"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/finish.svg'),
      "height": "45",
      "width": "45"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-size-12"
  }, [_vm._v("\n                                Status Finished\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text mt-1 font-size-24"
  }, [_vm._v("\n                                " + _vm._s(_vm.formatNumber(_vm.data.total_consul_finished)) + "\n                                "), _c('span', {
    staticClass: "font-size-12 font-weight-500"
  }, [_vm._v("\n                                    Finished\n                                ")])])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex align-center gap-10 pa-3"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/canceled.svg'),
      "height": "45",
      "width": "45"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-size-12"
  }, [_vm._v("\n                                Status Canceled\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text mt-1 font-size-24"
  }, [_vm._v("\n                                " + _vm._s(_vm.formatNumber(_vm.data.total_consul_canceled)) + "\n                                "), _c('span', {
    staticClass: "font-size-12 font-weight-500"
  }, [_vm._v("\n                                    Canceled\n                                ")])])])])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "d-flex align-center gap-10 pa-3"
  }, [_c('div', [_c('v-img', {
    attrs: {
      "src": require('@/assets/apps/timeout.svg'),
      "height": "45",
      "width": "45"
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "grey--text font-size-12"
  }, [_vm._v("\n                                Status Timeout\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-bold black--text mt-1 font-size-24"
  }, [_vm._v("\n                                " + _vm._s(_vm.formatNumber(_vm.data.total_consul_timeout)) + "\n                                "), _c('span', {
    staticClass: "font-size-12 font-weight-500"
  }, [_vm._v("\n                                    Timeout\n                                ")])])])])], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7984b1a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Konsul/components/ConsulActivityStatistic.vue
// module id = 1616
// module chunks = 1